import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { memo, useEffect } from 'react';
import Login from './pages/Login';
import Home from './pages/Home';
import Daily from './pages/Daily';
import DailyPrincipal from './pages/Daily_principal';
import DashboardUSDSales from './pages/DashboardUSDSales';
import DashboardBultos from './pages/DashboardBultos';
import DashboardAsesores from './pages/DashboardAsesores';
import DashboardInventario from './pages/DashboardInventario';
import DashboardActivacion from './pages/DashboardActivacion';
import DashboardSugeridos from './pages/DashboardSugeridos';
import SellOut from './pages/SellOut';
import SellOutModerno from './pages/SellOutMod';
import SellOutTradicional from './pages/SellOutTrad';
import Report from './pages/Report';
import Facturación from './pages/Facturación';
import KPIFact from './pages/KPIFact';
import DetalleFact from './pages/DetalleFact';
import NCredito from './pages/NCredito';
import ReportesAV from './pages/ReportesAV';
import Navbar from './components/Header';
import TradeForm from './pages/Trade-Form';
import TradeTrack from './pages/Trade-Track';
import TradeFlow from './pages/TradeFlow';
import Pedidos from './pages/Pedidos';
import PedidosMasivos from './pages/PedidosMasivos';
import AlmacenNotasEntrega from './pages/AlmacenNotasEntrega';
import AdminPermisos from './pages/AdminPermisos'; // NUEVA PANTALLA
import AdminUsuarios from './pages/AdminUsuarios';
import TalentoHumano from './pages/TalentoHumano';
import Surtido from './pages/Surtido';
import Reclutamiento from './pages/Reclutamiento';
import Catalogo from './pages/Catalogo';
import Cobranzas from './pages/Cobranzas';
import DetalleCob from './pages/DetalleCob';
import ReportCob from './pages/ReportCob';
import Cxccob from './pages/PanelCXCCob';
import Farmatodo from './pages/Farmatodo';
import InventarioAlmacen from './pages/InventarioAlmacen';
import Almacen from './pages/Almacen';
import PanelAlmacen from './pages/PanelAlmacen';
import ConsolidacionDespacho from './pages/ConsolidacionDespacho';
import DetalleNotasCredito from './pages/DetalleNotasCredito';
import PanelNotasCredito from './pages/PanelNotasCredito';
import NotasCAlmacen from './pages/NotasCAlmacen';
import './App.css';
import { AuthProvider, useAuth } from './AuthContext';
import { QueryProvider } from './QueryContext';

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/report" element={<ProtectedRoute><Report /></ProtectedRoute>} />
        <Route path="/daily" element={<ProtectedRoute><Daily /></ProtectedRoute>} />
        <Route path="/dprincipal" element={<ProtectedRoute><DailyPrincipal /></ProtectedRoute>} />
        <Route path="/bultos" element={<ProtectedRoute><DashboardBultos /></ProtectedRoute>} />
        <Route path="/usdsales" element={<ProtectedRoute><DashboardUSDSales /></ProtectedRoute>} />
        <Route path="/asesores" element={<ProtectedRoute><DashboardAsesores /></ProtectedRoute>} />
        <Route path="/inventario" element={<ProtectedRoute><DashboardInventario /></ProtectedRoute>} />
        <Route path="/activacion" element={<ProtectedRoute><DashboardActivacion /></ProtectedRoute>} />
        <Route path="/sugeridos" element={<ProtectedRoute><DashboardSugeridos /></ProtectedRoute>} />
        <Route path="/sellout" element={<ProtectedRoute><SellOut /></ProtectedRoute>} />
        <Route path="/sellout-moderno" element={<ProtectedRoute><SellOutModerno /></ProtectedRoute>} />
        <Route path="/sellout-tradicional" element={<ProtectedRoute><SellOutTradicional /></ProtectedRoute>} />
        <Route path="/facturacion" element={<ProtectedRoute><Facturación /></ProtectedRoute>} />
        <Route path="/kpi-fact" element={<ProtectedRoute><KPIFact /></ProtectedRoute>} />
        <Route path="/detalle-fact" element={<ProtectedRoute><DetalleFact /></ProtectedRoute>} />
        <Route path="/n-credito" element={<ProtectedRoute><NCredito /></ProtectedRoute>} />
        <Route path="/reportesav" element={<ProtectedRoute><ReportesAV /></ProtectedRoute>} />
        <Route path="/tradeform" element={<ProtectedRoute><TradeForm /></ProtectedRoute>} />
        <Route path="/tradetrack" element={<ProtectedRoute><TradeTrack /></ProtectedRoute>} />
        <Route path="/tradeflow" element={<ProtectedRoute><TradeFlow /></ProtectedRoute>} />
        <Route path="/pedidos" element={<ProtectedRoute><Pedidos /></ProtectedRoute>} />
        <Route path="/pedidosmasivos" element={<ProtectedRoute><PedidosMasivos /></ProtectedRoute>} />
        <Route path="/almacennotasentrega" element={<ProtectedRoute><AlmacenNotasEntrega /></ProtectedRoute>} />
        <Route path="/talentohumano" element={<ProtectedRoute><TalentoHumano /></ProtectedRoute>} />
        <Route path="/surtido" element={<ProtectedRoute><Surtido /></ProtectedRoute>} />
        <Route path="/reclutamiento" element={<ProtectedRoute><Reclutamiento /></ProtectedRoute>} />
        <Route path="/configuracion" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/catalogo" element={<ProtectedRoute><Catalogo /></ProtectedRoute>} />
        <Route path="/cobranzas" element={<ProtectedRoute><Cobranzas /></ProtectedRoute>} />
        <Route path="/detallecob" element={<ProtectedRoute><DetalleCob /></ProtectedRoute>} />
        <Route path="/reportcob" element={<ProtectedRoute><ReportCob /></ProtectedRoute>} />
        <Route path="/cxccob" element={<ProtectedRoute><Cxccob /></ProtectedRoute>} />
        <Route path="/farmatodo" element={<ProtectedRoute><Farmatodo /></ProtectedRoute>} />
        <Route path="/inventarioalmacen" element={<ProtectedRoute><InventarioAlmacen /></ProtectedRoute>} />
        <Route path="/almacen" element={<ProtectedRoute><Almacen /></ProtectedRoute>} />
        <Route path="/panelalmacen" element={<ProtectedRoute><PanelAlmacen /></ProtectedRoute>} />
        <Route path="/consolidaciondespacho" element={<ProtectedRoute><ConsolidacionDespacho /></ProtectedRoute>} />
        <Route path="/detalle-notascredito" element={<ProtectedRoute><DetalleNotasCredito /></ProtectedRoute>} />
        <Route path="/panel-notascredito" element={<ProtectedRoute><PanelNotasCredito /></ProtectedRoute>} />
        <Route path="/notascalmacen" element={<ProtectedRoute><NotasCAlmacen /></ProtectedRoute>} />
        {/* RUTA PROTEGIDA PARA ADMINISTRAR PERMISOS */}
        <Route path="/admin/permisos" element={<ProtectedRoute><AdminPermisos /></ProtectedRoute>} />
        <Route path="/admin/usuarios" element={<ProtectedRoute><AdminUsuarios /></ProtectedRoute>} />
      </Routes>
    </AnimatePresence>
  );
}

const AppContent = memo(function AppContent() {
  const location = useLocation();
  const showNavbar = location.pathname !== '/';

  useEffect(() => {
    if (location.pathname !== '/') {
      document.body.classList.add('app-global-bg');
    } else {
      document.body.classList.remove('app-global-bg');
    }
    return () => document.body.classList.remove('app-global-bg');
  }, [location.pathname]);

  return (
    <div className="app-container">
      {showNavbar && <Navbar />}
      <AnimatedRoutes />
    </div>
  );
});

const PublicOnlyRoute = memo(function PublicOnlyRoute({ children }) {
  return children;
});

const ProtectedRoute = memo(function ProtectedRoute({ children }) {
  const { session, isAuthResolved, hasAccess } = useAuth();
  const location = useLocation();
  
  if (!isAuthResolved) {
    return null;
  }

  if (!session) {
    return <Navigate to="/" replace />;
  }
  if (!hasAccess(location.pathname)) {
    return <Navigate to="/home" replace />;
  }
  return children;
});

function App() {
  return (
    <Router future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}>
      <AuthProvider>
        <QueryProvider>
          <AppContent />
        </QueryProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
